import React from "react";
import "./Button.css";
import { CircularProgress } from "@mui/material";

const CustomButton = ({
  Text,
  PrimaryColorBtn,
  navBar,
  className = "",
  isLoading,
  ...props
}) => {
  return (
    <button
      disabled={isLoading}
      {...props}
      className={` ${className ?? ""} 
       ${
        isLoading ? "disable" : "not-loading"
      } ${
        PrimaryColorBtn
          ? "btn  btn-primary "
          : "btn  btn-primary"
      } 
      ${navBar ? "btn_navbar_padding" : ""} btn-common-style`}
    >
      <p className="btn_common">
        {isLoading && (
          <CircularProgress
            sx={{ color: PrimaryColorBtn ? "#fff" : "#08632E" }}
            size={18}
          />
        )}
        {Text} 
        <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.88965 1L5.88965 5L1.88965 9"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
      </p>
    </button>
  );
};

export default CustomButton;
